import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArrowsLeftRight, Spinner } from "@phosphor-icons/react";

export default function Movement() {
  const [moves, setMoves] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { api.get("/movements").then(({ data }) => { setMoves(data); setLoading(false); }); }, []);

  return (
    <div className="space-y-5" data-testid="movement-page">
      <div><h1 className="font-display text-2xl lg:text-3xl font-bold tracking-tight">Movement</h1><p className="text-zinc-500 text-sm mt-1">Complete, append-only ledger of every asset movement.</p></div>

      {loading ? <div className="flex justify-center py-16"><Spinner size={28} className="animate-spin text-emerald-600" /></div> : moves.length === 0 ? (
        <div className="text-center py-16 text-zinc-400 border border-zinc-200 rounded-lg bg-white">No movements recorded yet.</div>
      ) : (
        <div className="rounded-lg border border-zinc-200 bg-white p-6">
          <ol className="relative border-l-2 border-zinc-200 ml-2 space-y-6">
            {moves.map((m) => (
              <li key={m.id} className="ml-6" data-testid={`move-${m.id}`}>
                <span className="absolute -left-[9px] h-4 w-4 rounded-full bg-emerald-500 border-2 border-white" />
                <div className="flex flex-wrap items-center justify-between gap-2">
                  <p className="font-semibold text-sm">{m.asset_label}</p>
                  <span className="text-xs text-zinc-400">{new Date(m.created_at).toLocaleString()}</span>
                </div>
                <p className="text-sm text-zinc-600 mt-1 flex items-center gap-2">
                  <span className="px-2 py-0.5 rounded bg-zinc-100">{m.from_location_name}</span>
                  <ArrowsLeftRight size={14} className="text-emerald-600" />
                  <span className="px-2 py-0.5 rounded bg-emerald-50 text-emerald-800 font-medium">{m.to_location_name}</span>
                </p>
                <p className="text-xs text-zinc-500 mt-1">by {m.user_name}{m.reason ? ` · ${m.reason}` : ""}</p>
                {m.notes && <p className="text-xs text-zinc-500">{m.notes}</p>}
              </li>
            ))}
          </ol>
        </div>
      )}
    </div>
  );
}
